import React from "react";
import { Logo } from "../../branding/Logo";
import { User } from "../../authentication/User";

export function Header({ withUser = true }: { withUser?: boolean }) {
    return (
        <header
            className={
                "bg-system-white h-header flex items-center px-[40px] justify-between"
            }
        >
            <Logo />
            {withUser && <User />}
        </header>
    );
}
